var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurations-legal-mentions"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-container',[_c('appLegalMentions')],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }